import React from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Dropdown,
  ButtonGroup,
} from "react-bootstrap";
import "../style.css"; // For custom styles
import Footer from "./footer";
import DashboardNavbar from "./DashboardNavbar";

const WithdrawSummary = () => {
  return (
    <div className="main-bg text-white min-vh-100 py-3">
      {/* NAVBAR */}
      <DashboardNavbar />

      {/* Main Content */}
      <Container className="container-lg mt-5">
        <Row className="justify-content-between align-items-center mb-3">
          <Col md="auto">
            <h3 className="fw-bold">Withdraw Request / Withdraw summary</h3>
          </Col>
          <Col md="auto">
            <p className="fs-6 fw-semibold m-0">
              Total: 5,000 | Deductions: 50
            </p>
          </Col>
        </Row>

        {/* Table */}
        <div className="table-container p-3 rounded">
          <Table hover borderless className="mb-0,">
            <thead>
              <tr className="table-header">
                <th>S No.</th>
                <th>User Id</th>
                <th>Amount</th>
                <th>Type</th>
                <th>Status</th>
                <th>Deductions</th>
                <th>Payable</th>
              </tr>
            </thead>
            <tbody>
              <tr className="table-row">
                <td>1</td>
                <td>21361</td>
                <td>5000</td>
                <td>Withdrawl</td>
                <td>Pending</td>
                <td>50</td>
                <td>4950</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default WithdrawSummary;
